import { ListSubheader } from "@mui/material";
import { TMenuOption } from "../ButtonMenu";
import { TRenderGroupProps } from "../ButtonMenu.types";
import Option from "./Option";

type TOptionGroupProps = {
  groupName: string;
  options: TMenuOption[];
} & TRenderGroupProps;

const OptionGroup = ({ groupName, options, ...props }: TOptionGroupProps) => (
  <>
    {groupName && <ListSubheader key={groupName}>{groupName}</ListSubheader>}
    {options.map((option) => (
      <Option
        key={option.id}
        option={option}
        shouldBeSeparated={!!option.shouldBeSeparated && options.length > 1}
        {...props}
      />
    ))}
  </>
);

export default OptionGroup;
